import React from "react";

export const MedicalDataVitalsIcon: React.FC = () => {
  return (
    <svg
      width="39px"
      height="36px"
      viewBox="0 0 39 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="LeftPannel-Patient-0"
          transform="translate(-14.000000, -50.000000)"
        >
          <g
            id="Vitals-menu-Copy-45"
            transform="translate(14.000000, 50.000000)"
          >
            <g id="Vitals-icon" transform="translate(7.000000, 6.000000)">
              <g id="Rectangle-Copy-206">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill="#208CFF"
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M17.0708319,9.0125108 C17.2458338,9.43543185 17.3333334,9.88022146 17.3333334,10.346893 C17.3333334,10.8573149 17.2276047,11.3385627 17.0161442,11.7906507 C16.8046836,12.2427387 16.5093725,12.6255495 16.1302019,12.9390944 C15.8531157,13.1943054 15.1385357,13.8469065 13.9864404,14.8969174 C12.9072625,15.8813026 12.2473698,16.4828623 12.0067423,16.7016146 C11.9265331,16.7672403 11.8353877,16.8000526 11.7333033,16.8000526 C11.6312189,16.8000526 11.5400735,16.7672403 11.4598643,16.7016146 C11.102569,16.3807779 10.1655941,15.524011 8.64891174,14.1312883 C7.92702926,13.4750315 7.515052,13.1031582 7.41296761,13.0156573 C7.38380064,12.9864903 7.35098829,12.9573238 7.31452958,12.9281568 C6.94265072,12.6146119 6.65463122,12.2336241 6.45046244,11.7851819 C6.24629366,11.3367398 6.14056498,10.8609607 6.13327324,10.3578305 C6.1259815,9.89845076 6.21348109,9.45366115 6.39577465,9.02344836 C6.56348472,8.61511079 6.8041086,8.25417497 7.11765352,7.94063005 C7.73015987,7.31354021 8.46296898,7 9.31610282,7 C9.78277433,7 10.225741,7.10208286 10.6450162,7.30625164 C11.0642914,7.51042043 11.4270501,7.79843993 11.7333033,8.17031878 C12.0395565,7.79843993 12.4023152,7.51042043 12.8215904,7.30625164 C13.2408656,7.10208286 13.6838323,7 14.1505038,7 C15.0036376,7 15.7364467,7.3098944 16.3489531,7.92969249 C16.662498,8.24323741 16.9031219,8.60417324 17.0708319,9.0125108 Z M12.3458066,8.75000939 C12.19268,8.95417818 11.9885143,9.05626104 11.7333033,9.05626104 C11.4780923,9.05626104 11.2739266,8.95417818 11.1208,8.75000939 C10.9020477,8.46563144 10.6340802,8.24323664 10.3168894,8.08281831 C9.99969866,7.92239998 9.66610645,7.84219202 9.31610282,7.84219202 C8.69630473,7.84219202 8.16036971,8.07187846 7.70828169,8.53125822 C7.47494594,8.76459397 7.29630093,9.03438439 7.17234132,9.34063756 C7.03379821,9.66147422 6.96817352,10.0005352 6.97546526,10.3578305 C6.97546526,10.7297094 7.0520274,11.0851765 7.20515399,11.4242425 C7.35828058,11.7633085 7.57702957,12.0495051 7.86140751,12.2828409 C7.875991,12.3047161 7.90515753,12.3302368 7.94890798,12.3594038 C7.95619973,12.3666955 7.96349136,12.377633 7.9707831,12.3922164 C8.10203446,12.5088843 8.44474121,12.8187787 8.99891362,13.3219089 L9.52391644,13.8031615 C10.5739273,14.7583798 11.3103822,15.42921 11.7333033,15.8156723 C12.0687234,15.5094191 12.6301792,14.9990048 13.4176873,14.2844141 C14.4020725,13.3729463 15.1202984,12.7166994 15.5723864,12.3156535 L15.5942615,12.2937784 C15.8713477,12.0677344 16.0900967,11.7870065 16.250515,11.4515864 C16.4109334,11.1015828 16.4911413,10.7333553 16.4911413,10.346893 C16.4911413,9.98959759 16.4255166,9.65053666 16.2942653,9.3297 C16.1703057,9.02344683 15.9916607,8.75365641 15.7583249,8.52032066 C15.3062369,8.06823264 14.7703019,7.84219202 14.1505038,7.84219202 C13.8005001,7.84219202 13.4669079,7.92057707 13.1497171,8.07734953 C12.8325264,8.23412199 12.5645589,8.4583397 12.3458066,8.75000939 Z"
                id="heart-o---anticon"
                stroke="#FFFFFF"
                strokeWidth="0.5"
                fill="#FFFFFF"
              ></path>
              <path
                d="M10.3598872,11.5910928 L10.0702447,12.1878066 L7.12853333,12.1878066 C6.83398147,12.1878066 6.5952,11.9490252 6.5952,11.6544733 C6.5952,11.3599214 6.83398147,11.12114 7.12853333,11.12114 L9.40231547,11.12114 L10.4434652,8.97619032 L11.5824081,11.762858 L12.6000612,9.66313034 L13.2484911,11.4914431 L13.5231691,11.1189619 L16.6387232,11.1441023 C16.9332655,11.1464791 17.1701124,11.3871795 17.1677357,11.6817218 C17.1653589,11.9762641 16.9246585,12.213111 16.6301162,12.2107343 L14.0586976,12.1899847 L12.9146784,13.7413489 L12.4474055,12.4238265 L11.4995541,14.3795321 L10.3598872,11.5910928 Z"
                id="Path-5"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
